import { VideoCallAction } from 'components/features/videoCalls/types/actions'
import { EpicRefined } from 'interfaces/middleware'
import { mergeMap, catchError } from 'rxjs/operators'
import { of, EMPTY } from 'rxjs'
import { filterAgoraStreamEvent, filterAgoraClientEvent } from 'components/features/videoCalls/helpers'
import { mergeMapAsync } from 'rxOperators/mergeMapAsync'
import { agoraInstances } from 'components/features/videoCalls/agoraInstances'

export const streamAddedEpic: EpicRefined<VideoCallAction> = (action$, store) => action$.pipe(
  filterAgoraClientEvent('stream-added'),
  mergeMap((event) => of(null).pipe(
    mergeMapAsync(async () => {
      const { videoCall } = store.getState().app
      const { streamId: localStreamId } = videoCall.localStream
      const { streamId: screenStreamId } = videoCall.screenStream
      const { clientId } = videoCall.client
      const client = agoraInstances.clients.get(clientId as any)
      if (!client) {
        return
      }

      const { stream } = event
      const streamId = +stream.getId()
      const isLocalStream = localStreamId && streamId === localStreamId
      const isScreenStream = screenStreamId && streamId === screenStreamId
      if (isLocalStream || isScreenStream) {
        return
      }

      agoraInstances.streams.set(streamId, stream)
      await new Promise<void>((resolve, reject) => {
        client.subscribe(stream, undefined, reject)
        resolve()
      })
    }),
    mergeMap(() => EMPTY),
    catchError(() => EMPTY)
  )),
)

export const streamRemovedEpic: EpicRefined<VideoCallAction> = (action$) => action$.pipe(
  filterAgoraClientEvent('stream-removed'),
  mergeMap((event) => {
    const id = +event.stream.getId()
    agoraInstances.streams.delete(id)
    return EMPTY
  }),
  catchError(() => EMPTY)
)

export const streamPausedEpic: EpicRefined<VideoCallAction> = (action$) => action$.pipe(
  filterAgoraStreamEvent('player-status-change'),
  mergeMap((event) => of(null).pipe(
    mergeMapAsync(async () => {
      if (event.status !== 'paused') {
        return
      }
      const stream = agoraInstances.streams.get(+event.streamId as any)
      if (!stream) {
        return
      }
      await stream.resume()
    }),
    mergeMap(() => EMPTY),
    catchError(() => EMPTY)
  ))
)
